import { useEffect, useState, FC } from "react";
import { styled } from "@mui/material";
import Select from "ui/molecules/Select";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormLabel from "@mui/material/FormLabel";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import LoadingButton from "@mui/lab/LoadingButton";

interface FilterProps {
  business: any;
  onSelectBusiness: any;
  userBusinesses: any;
  active: string;
  filterValue: string;
  vinculationType: string;
  setActive: any;
  setVinculationType: any;
  setFilterValue: any;
  loadingFile: boolean;
  handleExportFile: any;
  persons: any;
}

const Filters: FC<FilterProps> = (props) => {
  const {
    business,
    onSelectBusiness,
    userBusinesses,
    active,
    filterValue,
    vinculationType,
    setActive,
    setVinculationType,
    setFilterValue,
    loadingFile,
    handleExportFile,
    persons,
  } = props;
  return (
    <>
      <Select
        id='business'
        mapKey='code'
        name='business'
        margin='normal'
        label='Seleccione Finca'
        value={business.codeUp || ""}
        onChange={onSelectBusiness}
        dataSource={userBusinesses || []}
        mapValue='fullName'
      />
      <FormWrapper>
        <FormGroup1>
          <div>
            <FormLabel id='demo-row-radio-buttons-group-label' color='primary'>
              Usuario
            </FormLabel>
            <RadioGroup
              row
              defaultValue='true'
              value={active}
              aria-labelledby='demo-row-radio-buttons-group-label'
              name='row-radio-buttons-group'
              onChange={(event) => setActive(event.target.value)}
            >
              <FormControlLabel value='true' control={<Radio color='primary' />} label='Activo' />
              <FormControlLabel value='false' control={<Radio />} label='Retirado' />
            </RadioGroup>
          </div>
          <div>
            <FormLabel id='demo-row-radio-buttons-group-label' color='primary'>
              Vinculación
            </FormLabel>
            <RadioGroup
              row
              defaultValue='ALL'
              value={vinculationType}
              aria-labelledby='demo-row-radio-buttons-group-label'
              name='row-radio-buttons-group'
              onChange={(event) => setVinculationType(event.target.value)}
            >
              <FormControlLabel value='ALL' control={<Radio color='primary' />} label='Todos' />
              <FormControlLabel value='Directos' control={<Radio />} label='Directos' />
              <FormControlLabel value='Temporales' control={<Radio />} label='Temporales' />
            </RadioGroup>
          </div>
        </FormGroup1>

        <FormGroup2>
          <FormLabel id='demo-row-radio-buttons-group-label' color='primary'>
            Filtros
          </FormLabel>
          <RadioGroup
            row
            defaultValue='ALL'
            value={filterValue}
            aria-labelledby='demo-row-radio-buttons-group-label'
            name='row-radio-buttons-group'
            onChange={(event) => setFilterValue(event.target.value)}
          >
            <FormControlLabel value='ALL' control={<Radio color='primary' />} label='Ver Todo' />
            <FormControlLabel value='SENT' control={<Radio />} label='Encuestas enviadas' />
            <FormControlLabel value='NO_SENT' control={<Radio />} label='Encuestas no enviadas' />

            <ButtonStyled
              color='primary'
              variant='outlined'
              loading={loadingFile}
              loadingPosition='start'
              startIcon={<CloudDownloadIcon />}
              onClick={handleExportFile}
              disabled={!persons?.length}
            >
              {`${loadingFile ? "Descargando..." : "Descargar Excel"}`}
            </ButtonStyled>
          </RadioGroup>
        </FormGroup2>
      </FormWrapper>
    </>
  );
};

export default Filters;

const ButtonStyled = styled(LoadingButton)`
  min-width: 200px;
  margin: 0.25rem;
`;

const FormWrapper = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "center",

  "& > :nth-child(1)": {
    marginLeft: 0,
    marginRight: 5,
  },

  "& > :nth-child(2)": {
    marginLeft: "0.5rem",
    marginRight: "0.5rem",
  },

  [theme.breakpoints.up("md")]: {
    "& > :last-child": {
      flex: 2,
      marginLeft: 0,
      marginRight: 0,
    },
  },

  [theme.breakpoints.down("md")]: {
    flexDirection: "column",
  },
}));

export const miMixin = () => ({
  border: "1px solid #ccc",
  width: "100%",
  margin: "0.5rem",
  marginBottom: "0.5rem",
  padding: "0.5rem",
});

const FormGroup1 = styled("div")(({ theme }) => ({
  display: "flex",
  flex: 1,
  ...miMixin(),
  [theme.breakpoints.down("sm")]: {
    display: "flex",
    flexDirection: "row",
  },
}));

const FormGroup2 = styled("div")(({ theme }) => ({
  flex: 2,
  ...miMixin(),
  [theme.breakpoints.up("md")]: {
    minHeight: "7.8rem",
  },
  [theme.breakpoints.down("sm")]: {
    height: "auto",
  },
}));
